import { graphql } from '../../../graphql/generated';

export const PATIENT_REQUESTS_QUERY = graphql(`
  query PatientRequests($doctorId: ID!, $svnr: String!) {
    patientRequests(doctorId: $doctorId, svnr: $svnr) {
      id
      createdAt
      reorderable
      reorderableUntil
      createdByFrontDesk
      status
      comment
      orders {
        id
        lab {
          id
        }
        orderParameters {
          id
          shortName
          longName
          billingType
        }
      }
      patientData {
        birthday
        city
        country
        email
        externalId
        firstName
        lastName
        gender
        zip
        svnr
        title
        street
        phone
        insuranceCode
        idCardAuthority
        idCardNumber
        idCardType
        insuranceCategory
        insuredPerson {
          phone
          street
          title
          svnr
          zip
          birthday
          gender
          firstName
          email
          country
          city
          lastName
        }
      }
    }
  }
`);
